const DANH_SACH_VAN_BAN_DEN = (state, danhSachVanBanDen) => {
  state.danhSachVanBanDen = danhSachVanBanDen;
};
const SET_DANH_SACH_COT_VAN_BAN_DEN = (state, danhSachHienThiCotVanBanDen) => {
  state.danhSachHienThiCotVanBanDen = danhSachHienThiCotVanBanDen;
};

const CAP_NHAT_DANH_SACH_COT_VAN_BAN_DEN = (
  state,
  danhSachHienThiCotVanBanDenCapNhat
) => {
  state.danhSachHienThiCotVanBanDenCapNhat = danhSachHienThiCotVanBanDenCapNhat;
};

const DANH_SACH_TAT_CA_TRANG_THAI = (state, danhSachTatCaTrangThai) => {
  state.danhSachTatCaTrangThai = danhSachTatCaTrangThai;
};

const DANH_SACH_DON_VI_THU_HOI = (state, danhSachDonViThuHoi) => {
  state.danhSachDonViThuHoi = danhSachDonViThuHoi;
};

const NGUOI_BI_TRA_LAI = (state, nguoiBiTraLai) => {
  state.nguoiBiTraLai = nguoiBiTraLai;
};

const DANH_SACH_LOAI_VAN_BAN = (state, danhSachLoaiVanBan) => {
  state.danhSachLoaiVanBan = danhSachLoaiVanBan;
};

const DANH_SACH_SO_VAN_BAN = (state, danhSachSoVanBan) => {
  state.danhSachSoVanBan = danhSachSoVanBan;
};

const DANH_SACH_PHUONG_THUC_NHAN = (state, danhSachPhuongThucNhan) => {
  state.danhSachPhuongThucNhan = danhSachPhuongThucNhan;
};

const DANH_SACH_LOAI_VAN_BAN_CHUA_VAO_SO = (
  state,
  danhSachLoaiVanBanChuaVaoSo
) => {
  state.danhSachLoaiVanBanChuaVaoSo = danhSachLoaiVanBanChuaVaoSo;
};

const DANH_SACH_DO_KHAN = (state, danhSachDoKhan) => {
  state.danhSachDoKhan = danhSachDoKhan;
};

const DANH_SACH_DON_VI_NGOAI = (state, danhSachDonViNgoai) => {
  state.danhSachDonViNgoai = danhSachDonViNgoai;
};

const DANH_SACH_DON_VI_NGOAI_KO_LIEN_THONG = (state, danhSachDonViNgoaiKhongLienThong) => {
  state.danhSachDonViNgoaiKhongLienThong = danhSachDonViNgoaiKhongLienThong;
};

const DANH_SACH_OPT_DON_VI = (state, danhSachOptionDonVi) => {
  state.danhSachOptionDonVi = danhSachOptionDonVi;
};

const CHI_TIET_VAN_BAN_DEN = (state, chiTietVanBanDen) => {
  state.chiTietVanBanDen = chiTietVanBanDen;
};

const DANH_SACH_FILE_VAN_BAN_DEN = (state, danhSachFileVanBanDen) => {
  state.danhSachFileVanBanDen = danhSachFileVanBanDen;
};

const DANH_SACH_XEM_LUONG_PHAN_XU_LY = (state, danhSachXemLuongPhanXuLy) => {
  state.danhSachXemLuongPhanXuLy = danhSachXemLuongPhanXuLy;
};
const LAY_DANH_SACH_Y_KIEN_XU_LY_VAN_BAN = (state, danhSachYKienVanBan) => {
  state.danhSachYKienVanBan = danhSachYKienVanBan;
};
const DANH_SACH_DON_VI_LANH_DAO = (state, danhSachLanhDaoDonVi) => {
  state.danhSachLanhDaoDonVi = danhSachLanhDaoDonVi;
};

const LAY_DANH_SACH_CAN_BO_XIN_Y_KIEN = (state, danhSachCanBoXinYKien) => {
  state.danhSachCanBoXinYKien = danhSachCanBoXinYKien;
};

const LAY_DANH_SACH_NHOM_LAM_VIEC = (state, danhSachNhomLamViec) => {
  state.danhSachNhomLamViec = danhSachNhomLamViec;
};
const SET_DANH_SACH_NHOM_LAM_VIEC_PAGING =(state,danhSachNhomLamViec)=>{
  state.danhSachNhomLamViec=danhSachNhomLamViec;
}

const DATA_FILTER_DASHBOARD = (state, data) => {
  state.dataFilterDashboard = data;
};

const SET_DATE_FILTER = (state, data) => {
  state.dateFilterTable = data;
};

const DANH_SACH_DON_VI_CA_NHAN_PXL = (state, data) => {
  state.danhSachDonViCaNhanPXL = data;
}

const DANH_SACH_SO_BY_DON_VI = (state , data) => {
  state.danhSachSoByDonVi = data
}

const SET_PAGE_INDEX = (state , data) => {
  state.pageIndex = data
}

const SET_KEEP_ALIVE_PAGE = (state , data) => {
  state.keepAlivePage = data
}

export default {
  SET_KEEP_ALIVE_PAGE,
  SET_DATE_FILTER,
  SET_PAGE_INDEX,
  SET_DANH_SACH_NHOM_LAM_VIEC_PAGING,
  DATA_FILTER_DASHBOARD,
  DANH_SACH_VAN_BAN_DEN,
  SET_DANH_SACH_COT_VAN_BAN_DEN,
  CAP_NHAT_DANH_SACH_COT_VAN_BAN_DEN,
  DANH_SACH_TAT_CA_TRANG_THAI,
  DANH_SACH_DON_VI_THU_HOI,
  DANH_SACH_LOAI_VAN_BAN,
  DANH_SACH_SO_VAN_BAN,
  DANH_SACH_PHUONG_THUC_NHAN,
  DANH_SACH_LOAI_VAN_BAN_CHUA_VAO_SO,
  DANH_SACH_DO_KHAN,
  DANH_SACH_DON_VI_NGOAI,
  DANH_SACH_DON_VI_NGOAI_KO_LIEN_THONG,
  DANH_SACH_OPT_DON_VI,
  DANH_SACH_FILE_VAN_BAN_DEN,
  CHI_TIET_VAN_BAN_DEN,
  NGUOI_BI_TRA_LAI,
  DANH_SACH_XEM_LUONG_PHAN_XU_LY,
  LAY_DANH_SACH_Y_KIEN_XU_LY_VAN_BAN,
  LAY_DANH_SACH_CAN_BO_XIN_Y_KIEN,
  DANH_SACH_DON_VI_LANH_DAO,
  LAY_DANH_SACH_NHOM_LAM_VIEC,
  DANH_SACH_DON_VI_CA_NHAN_PXL,
  DANH_SACH_SO_BY_DON_VI
};
